import "../../../../stylesheets/causes";
import "../../../../stylesheets/templates/causes/template-1";
import "../../../../stylesheets/templates/causes/template-2";
import AutoNumeric from "autonumeric";
import "./index";
import "./greeting_cards";
import "select2";
import "select2/dist/css/select2.css";

function causeDonationAmountField() {
  return document.getElementById(
    "donator_donation_transactions_attributes_0_amount"
  );
}

function isCauseDonationAmountEditable() {
  const el = causeDonationAmountField();
  if (!el) {
    return false;
  }
  return !el.disabled && el.type !== "hidden";
}

function clearCauseDonationAmountField() {
  const el = causeDonationAmountField();
  if (!el) {
    return;
  }
  const an = AutoNumeric.getAutoNumericElement(el);
  if (an) {
    an.set("");
  } else {
    el.value = "";
  }
  $(el).trigger("input");
}

function bindMultipleCauseSubscriptionModalHandlers() {
  if (bindMultipleCauseSubscriptionModalHandlers.bound) {
    return;
  }
  bindMultipleCauseSubscriptionModalHandlers.bound = true;

  $(document).on("click", "#multiple-cause-subscription-continue", function (e) {
    e.preventDefault();
    $("#confirm_multiple_cause_subscription_field").val("1");
    $("#multiple-cause-subscription-modal").modal("hide");
    const form = $("#new_donator");
    if (form.length) {
      form.trigger("submit");
    } else {
      $("#loader").hide();
    }
  });

  $(document).on("click", "#multiple-cause-subscription-cancel", function (e) {
    e.preventDefault();
    if (isCauseDonationAmountEditable()) {
      $("#confirm_multiple_cause_subscription_field").val("");
      clearCauseDonationAmountField();
    }
    $("#multiple-cause-subscription-modal").modal("hide");
    const noRecurring = $('#single-donation[name="recurring_radio"]');
    if (noRecurring.length) {
      noRecurring.prop("checked", true).trigger("change");
    }
    $("#loader").hide();
  });
}

bindMultipleCauseSubscriptionModalHandlers();

$(".standard-select")
  .select2({
    placeholder: "",
    allowClear: true,
  })
  .next(".select2-container")
  .find("span.select2-selection--single")
  .css("border-radius", "57px");

$("#recruiter_form_card .selection").on("click", function () {
  if ($(".select2-results")) {
    $(".select2-results").hide();
    window.scroll(0, $(window).scrollTop() + 1);
  }
});

$(".select2-search__field").on("input", function () {
  if (this.value) {
    $(".select2-results").show();
  } else {
    $(".select2-results").hide();
    window.scroll(0, $(window).scrollTop() - 1);
  }
});

const greetingCardRadios = document.querySelectorAll(
  "input.template-selection[data-amount]"
);

if (greetingCardRadios.length > 0) {
  const amountInput = document.querySelector(
    ".amountInput.greeting-card-amount"
  );
  const usdButton = document.querySelector(
    ".currency-selector-button[data-currency='usd']"
  );
  const clpButton = document.querySelector(
    ".currency-selector-button[data-currency='clp']"
  );
  const ufButton = document.querySelector(
    ".currency-selector-button[data-currency='uf']"
  );

  if (ufButton) {
    ufButton.style.display = "none";
  }

  const greetingCardFeedback = document.querySelector(
    ".greeting-card-feedback"
  );
  const minAmountPlaceholder = document.querySelector(
    ".min-amount-placeholder"
  );
  let selectedCurrency = "CLP";
  let minAmount = null;
  function formatAmount(amount) {
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }
  function updateGreetingCardAmount() {
    const selectedCard = document.querySelector(
      "input.template-selection:checked"
    );

    if (selectedCard) {
      const amount = parseFloat(selectedCard.getAttribute("data-amount"));
      const usdAmount = parseFloat(
        selectedCard.getAttribute("data-usd-amount")
      );
      if (usdAmount) {
        usdButton.style.visibility = "visible";
      } else {
        usdButton.style.visibility = "hidden";
        selectedCurrency = "CLP";
      }

      minAmount =
        selectedCurrency === "usd" && usdAmount
          ? usdAmount
          : selectedCurrency === "usd"
            ? 1
            : amount;

      const formattedPlaceholder = `Mínimo de ${formatAmount(
        minAmount
      )} ${selectedCurrency.toUpperCase()}`;

      amountInput.placeholder = formattedPlaceholder;
      minAmountPlaceholder.textContent = `${formatAmount(
        minAmount
      )} ${selectedCurrency.toUpperCase()}`;
    }

    amountInput.value = "";
  }

  $(".template-selection[data-amount]").on("change", updateGreetingCardAmount);
  $(".currency-selector-button").on("click", function () {
    selectedCurrency = $(this).data("currency");
    updateGreetingCardAmount();
  });

  $(".amountInput.greeting-card-amount").on("input", function () {
    const enteredAmount = parseFloat($(this).val().replace(/\./g, ""));
    if (enteredAmount < minAmount) {
      this.setCustomValidity(
        `Por favor, ingresa un monto mínimo de ${formatAmount(
          minAmount
        )} ${selectedCurrency.toUpperCase()}`
      );
      greetingCardFeedback.style.display = "block";
    } else {
      this.setCustomValidity("");
      greetingCardFeedback.style.display = "none";
    }
  });

  $(".template-selection[data-amount], .currency-selector-button").on(
    "change click",
    function () {
      const formattedPlaceholder = `Mínimo de ${formatAmount(
        minAmount
      )} ${selectedCurrency.toUpperCase()}`;
      amountInput.placeholder = formattedPlaceholder;
    }
  );

  // Inicializar valores
  updateGreetingCardAmount();
}
